import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { CheckSvg } from './Check';

export const CheckIcon = createIcon('check', CheckSvg);
/**
 * @deprecated используйте CheckIcon
 */
export const withCheckIcon = withIcon('check', CheckSvg);
